import { Icon } from "@iconify/react";
import style from "./sidebar-toggle.module.scss";
import { useSidebar } from "@/context/SidebarContext";

const SidebarToggle = () => {
    const { toggleSidebar } = useSidebar();
    return (
        <>
            <button className={style.sidebar_toggle} onClick={toggleSidebar}>
                <Icon icon="material-symbols:menu-rounded" fontSize="1.5rem" />
            </button>
        </>
    );
};

export default SidebarToggle;
